import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form", attrs: { id: "dynamicQrCodeForm" } },
    [
      _vm.loaded
        ? _c(
            VForm,
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(VTextField, {
                attrs: { label: "ID", required: true },
                model: {
                  value: _vm.dynamicQrCode.uuid,
                  callback: function ($$v) {
                    _vm.$set(_vm.dynamicQrCode, "uuid", $$v)
                  },
                  expression: "dynamicQrCode.uuid",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Staff", required: true },
                model: {
                  value: _vm.dynamicQrCode.staffId,
                  callback: function ($$v) {
                    _vm.$set(_vm.dynamicQrCode, "staffId", $$v)
                  },
                  expression: "dynamicQrCode.staffId",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Type", required: false },
                model: {
                  value: _vm.dynamicQrCode.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.dynamicQrCode, "type", $$v)
                  },
                  expression: "dynamicQrCode.type",
                },
              }),
              _c(VTextField, {
                attrs: { label: "Data", required: false },
                model: {
                  value: _vm.dynamicQrCode.jsonData,
                  callback: function ($$v) {
                    _vm.$set(_vm.dynamicQrCode, "jsonData", $$v)
                  },
                  expression: "dynamicQrCode.jsonData",
                },
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-space-between" },
                [
                  _c(VBtn, { on: { click: _vm.goBack } }, [
                    _vm._v(" Back "),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(" " + _vm._s(_vm.id ? "Update" : "Save") + " ")]
                  ),
                  _c("span"),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }